// Mismos titulos que las tarjetas del paso `business-type` del onboarding.
export const businessTypesCodes = {
    share_only: "Profesional",
    organization: "Organización",
    social_seller: "Tienda en línea",
    single_store: "Tienda física",
    multi_store: "Sucursales"
};

// ampliar-business-types: tipos sin productos (en el backend, su default trae
// `productsEnabled: false`). No pasan por el step `products` del onboarding.
export const BUSINESS_TYPES_WITHOUT_PRODUCTS = ["share_only", "organization"];
